import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-veer-brand-logo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      class="veer-brand-logo"
      [ngClass]="sizeClass"
      [src]="logoSrc"
      alt="Veer Solutions"
      decoding="async"
    />
  `,
  styles: [
    `
      .veer-brand-logo {
        display: block;
        object-fit: contain;
        flex-shrink: 0;
      }

      .veer-brand-logo--sm {
        height: 2rem;
        width: auto;
      }

      .veer-brand-logo--md {
        height: 3rem;
        width: auto;
      }

      .veer-brand-logo--lg {
        height: 5.5rem;
        width: auto;
      }
    `
  ]
})
export class VeerBrandLogoComponent {
  @Input() variant: 'full' | 'mark' = 'full';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get sizeClass(): string {
    return `veer-brand-logo--${this.size}`;
  }

  get logoSrc(): string {
    return this.variant === 'full'
      ? 'assets/branding/veer-solutions-full.png'
      : 'assets/branding/veer-solutions-mark.png';
  }
}
